import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

const INNER_W = 680;
const INNER_H = 520;
const SCALE = 0.58;

export const useStyles = makeStyles({
  outer: {
    width: `${Math.round(INNER_W * SCALE)}px`,
    height: `${Math.round(INNER_H * SCALE)}px`,
    overflow: "hidden",
    borderRadius: designTokens.borderRadius.md,
    border: `1px solid ${designTokens.neutral[200]}`,
    backgroundColor: designTokens.neutral.white,
  },
  inner: {
    width: `${INNER_W}px`,
    height: `${INNER_H}px`,
    transform: `scale(${SCALE})`,
    transformOrigin: "top left",
    display: "flex",
    flexDirection: "column",
    backgroundColor: designTokens.neutral.white,
    overflow: "hidden",
  },
  headerArea: {
    flexShrink: 0,
    backgroundColor: designTokens.neutral.white,
    pointerEvents: "none",
  },
  body: {
    display: "flex",
    flex: 1,
    overflow: "hidden",
  },
  sidebarWrapper: {
    overflow: "hidden",
    flexShrink: 0,
    pointerEvents: "none",
  },
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    backgroundColor: designTokens.neutral.white,
    overflow: "hidden",
  },
  messagesArea: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[3],
    padding: designTokens.spacing[4],
    paddingBottom: "0",
    overflow: "hidden",
  },
  aiBubbleRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: designTokens.spacing[2],
  },
  aiAvatar: {
    width: "32px",
    height: "32px",
    borderRadius: designTokens.borderRadius.full,
    backgroundColor: designTokens.primary[900],
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    color: designTokens.primary[300],
  },
  aiBubble: {
    backgroundColor: designTokens.neutral[100],
    borderRadius: `0 ${designTokens.borderRadius.lg} ${designTokens.borderRadius.lg} ${designTokens.borderRadius.lg}`,
    padding: `${designTokens.spacing[3]} ${designTokens.spacing[4]}`,
    maxWidth: "75%",
    fontSize: designTokens.fontSize.sm,
    color: designTokens.neutral[800],
    lineHeight: "1.5",
    boxShadow: designTokens.shadow.sm,
  },
  userBubbleRow: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-end",
    gap: designTokens.spacing[2],
  },
  userAvatar: {
    width: "28px",
    height: "28px",
    marginTop: designTokens.spacing[3],
    borderRadius: designTokens.borderRadius.full,
    backgroundColor: designTokens.primary[100],
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    color: designTokens.primary[600],
  },
  userBubble: {
    backgroundColor: designTokens.primary[50],
    border: `1px solid ${designTokens.primary[100]}`,
    borderRadius: `${designTokens.borderRadius.lg} 0 ${designTokens.borderRadius.lg} ${designTokens.borderRadius.lg}`,
    padding: `${designTokens.spacing[3]} ${designTokens.spacing[4]}`,
    maxWidth: "70%",
    fontSize: designTokens.fontSize.sm,
    color: designTokens.primary[800],
    lineHeight: "1.5",
  },
  inputContainer: {
    flexShrink: 0,
    paddingTop: designTokens.spacing[3],
    paddingLeft: designTokens.spacing[4],
    paddingRight: designTokens.spacing[4],
    paddingBottom: designTokens.spacing[3],
    backgroundColor: designTokens.neutral.white,
  },
  inputCard: {
    backgroundColor: designTokens.neutral.white,
    border: `1px solid ${designTokens.neutral[200]}`,
    borderRadius: designTokens.borderRadius.xl,
    boxShadow: designTokens.shadow.md,
    overflow: "hidden",
  },
  previewTabBar: {
    display: "flex",
    alignItems: "center",
    minHeight: "44px",
    padding: `${designTokens.spacing[2]} ${designTokens.spacing[3]}`,
    borderBottom: `1px solid ${designTokens.neutral[200]}`,
  },
  previewTabGroup: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[1],
  },
  previewTab: {
    flexShrink: 0,
    whiteSpace: "nowrap" as const,
    padding: `${designTokens.spacing[1]} ${designTokens.spacing[3]}`,
    borderRadius: designTokens.borderRadius.md,
    fontSize: designTokens.fontSize.sm,
    color: designTokens.neutral[400],
  },
  previewTabActive: {
    flexShrink: 0,
    whiteSpace: "nowrap" as const,
    padding: `${designTokens.spacing[1]} ${designTokens.spacing[3]}`,
    borderRadius: designTokens.borderRadius.md,
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.semibold,
  },
  previewTextPanel: {
    padding: `${designTokens.spacing[2]} ${designTokens.spacing[3]}`,
  },
  previewTextPanelBody: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[3],
  },
  previewTextareaPlaceholder: {
    flex: 1,
    fontSize: designTokens.fontSize.sm,
    color: designTokens.neutral[400],
    lineHeight: "1.5",
  },
  previewSendBtn: {
    width: "36px",
    height: "36px",
    minWidth: "36px",
    borderRadius: designTokens.borderRadius.md,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  previewKbdHint: {
    display: "block",
    textAlign: "right" as const,
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[400],
    paddingTop: designTokens.spacing[1],
  },
});
